import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import UserDetailsPage, { getDefaultData } from "components/pages/UserDetailsPage";
import Classes from "model";

/**
 * @name CaptureAddUserFilled
 * @returns {React.Component}
 * @description 
 */
export default function CaptureAddUserFilled(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "userAccount" ], BCMSDefaultModel.userAccount() )
    .submit();

    return <UserDetailsPage data={ data } />
}